<script lang="ts">
import { Button, Column, Form, Grid, Loading, PasswordInput, Row, TextInput } from "carbon-components-svelte";
import DirectionStraightRight from "carbon-icons-svelte/lib/DirectionStraightRight.svelte";
import type { Repository } from "../libraries/repository";
import { Credentials } from "../model/credentials";
import type { RepositoryResponse } from "../model/repositoryResponse";
import { Utils } from "../utils/utils";
import NotificationInline from "./NotificationInline.svelte";

let credentials: Credentials = new Credentials();
export let repository:Repository;
let response: RepositoryResponse;
$: isLoading = false;

function makeLogin() {
    isLoading = true;
    repository.logIn(credentials).then((res) => {response = res;  isLoading = false;})
}
</script>


<Grid class="mt-3">
    {#if isLoading}
    <Loading />
    {:else}
    <Row>
        <Column sm={0} md={2} lg={5}></Column>
        <Column sm={4} md={4} lg={6}>
            <Form on:submit={(e) => { makeLogin(); e.preventDefault(); }} class="login-container">
                <h2 class="mb-1">Log in</h2>
                <TextInput required type="text" bind:value={credentials.username} labelText="Username" />
                <PasswordInput required type="password" labelText="Password" bind:value={credentials.password} 
                    hidePasswordLabel="Nascondi password" showPasswordLabel="Mostra password"/>
                <Button  type="submit" icon={DirectionStraightRight}>Entra</Button>
            </Form>
        </Column>
        <Column sm={0} md={2} lg={5}></Column>
    </Row>

    {#if response && !response.success}
    <Row>
        <Column sm={0} md={2} lg={5}></Column>
        <Column sm={4} md={4} lg={6}>
            <NotificationInline title="Errore" subtitle={Utils.errorMessage(response)} kind="error" onClose={null} />
        </Column>
        <Column sm={0} md={2} lg={5}></Column>
    </Row>
    {/if}
    {/if}
</Grid>
